
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/custom-ai",
      function () {
        return require("private-next-pages/custom-ai.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/custom-ai"])
      });
    }
  